import React, { useEffect, useState } from "react";
import Dashboard from "../Dashboard";
import AdminBundleManagement from "../../../features/adminDashboard/bundle/adminbundle/AdminBundleManagement/AdminBundleManagement";
import BundleForm from "../../../features/adminDashboard/bundle/adminbundle/AdminBundleManagement/BundleForm";

function BundleManagement() {
  const [activeTab, setActiveTab] = useState("list");

  return (
    <Dashboard>
      <div className="w-full h-full px-4 pb-8">
        {/* Tab Navigation */}
        <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6">
          <button
            onClick={() => setActiveTab("list")}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
              activeTab === "list"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            List Bundles
          </button>
          <button
            onClick={() => setActiveTab("create")}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
              activeTab === "create"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            Create Bundle
          </button>
        </div>
      </div>
      {activeTab === "list" && (
        <AdminBundleManagement onSetActiveTab={setActiveTab} />
      )}
      {activeTab === "create" && <BundleForm onSetActiveTab={setActiveTab} />}
    </Dashboard>
  );
}

export default BundleManagement;
